<template>
  <div class="modal fade show" :ref="ref" :id="ref" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-success">
        <div class="modal-header">
          <div class="title">{{ $t('pages.login.login') }}</div>
        </div>
        <div class="modal-body text-center">
          <p v-html="$t('pages.login.modal_conflict_login_content')"></p>
        </div>
        <div class="modal-footer pt-0">
          <button type="button" class="btn btn-common w-100" @click="onLogin">{{ $t('pages.login.btn_force_login') }}</button>
          <button type="button" class="btn btn-border w-100 mt-10" @click="onCloseModal">{{ $t('common.btn_cancel') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalMixin from '@/components/commons/modalMixin';

export default {
  mixins: [modalMixin],
  name: 'ModalConflictLogin',
  data () {
    return {
      ref: 'ModalConflictLogin',
    }
  },
  methods: {
    onLogin () {
      this.$emit('forceLogin')
    },
    onCloseModal () {
      this.closeModal();
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ModalConflictLogin.vue